// v2/hooks/useClickOutside.js
// panelRef disina tiklaninca kapatir. triggerRef HARIC tutulur:
// aksi halde butona ikinci tikta once kapanir, sonra onClick tekrar acar.
import { useEffect } from 'react';

export default function useClickOutside(panelRef, triggerRef, onClose, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (e) => {
      const p = panelRef.current;
      const t = triggerRef && triggerRef.current;
      if (p && p.contains(e.target)) return;
      if (t && t.contains(e.target)) return;
      onClose();
    };
    const esc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', esc);
    };
  }, [panelRef, triggerRef, onClose, active]);
}
